
import { Vue } from "vue-class-component";

export default class Transit extends Vue {}
